import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const UploadArrow = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M11.543 15.5V6.9l-2.3 2.3-.646-.643L12 5.154l3.412 3.403-.646.642-2.3-2.3V15.5h-.923ZM6.69 18.846c-.43 0-.794-.148-1.091-.445a1.485 1.485 0 0 1-.445-1.092v-2.39h.923v2.389c0 .154.064.295.192.423s.27.192.423.192h10.616a.588.588 0 0 0 .423-.192.588.588 0 0 0 .192-.423v-2.39h.923v2.391c0 .431-.148.796-.445 1.092-.296.297-.66.445-1.09.445H6.69Z"
    />
  </Svg>
)
export default UploadArrow
